import {
  ICON_MISC_OVERVIEW,
  ICON_TIME_LOCATION_HOTEL_BED,
  ICON_TIME_LOCATION_HOTEL,
  ICON_FOOD_BEVERAGE_RESTAURANT,
  ICON_MISC_POOL_BEACH,
  ICON_MISC_FITNESS,
  ICON_MISC_SPA,
  ICON_TIME_LOCATION_PIN,
  ICON_TIME_LOCATION_MAP,
  ICON_WEATHER_SUN_CLOUDS,
  ICON_COMMS_REVIEW,
  ICON_ESG_SUSTAINABLE,
  ICON_MISC_KIDS,
  ICON_MISC_ENTERTAINMENT,
  ICON_MISC_WHEELCHAIR,
} from '@bwoty-web/ui-kit/icons';

export const sectionKeys = {
  accommodation: 'accommodation',
  accessibility: "accessibility",
  foodAndBeverage: 'foodAndBeverage',
  poolAndBeach: 'poolAndBeach',
  sportsRelaxationEntertainment: 'sportsRelaxationEntertainment',
  spa: 'spa',
  kidsFacilities: 'kidsFacilities',
  locationAndTransfer: 'locationAndTransfer',
  rating: 'rating',
  map: 'map',
  weather: 'weather',
  show: 'show',
  sustainability: 'sustainability',
  overview: 'overview',
  description: 'description',
};

export const sectionIcons = {
  accommodation: ICON_TIME_LOCATION_HOTEL_BED,
  accessibility: ICON_MISC_WHEELCHAIR,
  foodAndBeverage: ICON_FOOD_BEVERAGE_RESTAURANT,
  poolAndBeach: ICON_MISC_POOL_BEACH,
  sportsRelaxationEntertainment: ICON_MISC_FITNESS,
  spa: ICON_MISC_SPA,
  kidsFacilities: ICON_MISC_KIDS,
  locationAndTransfer: ICON_TIME_LOCATION_PIN,
  rating: ICON_COMMS_REVIEW,
  map: ICON_TIME_LOCATION_MAP,
  weather: ICON_WEATHER_SUN_CLOUDS,
  show: ICON_MISC_ENTERTAINMENT,
  sustainability: ICON_ESG_SUSTAINABLE,
  overview: ICON_MISC_OVERVIEW,
  description: ICON_TIME_LOCATION_HOTEL,
  lounge: ICON_MISC_ENTERTAINMENT,
};

// Image sections to show in the gallery, order is important
// Possible to move to Umbraco, consider it
export const imageSections = {
  video: ['video'],
  description: ['hotel', 'lounge', 'interior'],
  accommodation: ['bathroom', 'bedroom'],
  foodAndBeverage: ['restaurant', 'food'],
  poolAndBeach: ['pool', 'beach'],
  sportsRelaxationEntertainment: [
    'gym',
    'activity',
    'sport',
    'spa',
    'entertainment',
  ],
  kids: ['kids'],
  locationAndTransfer: ['transport', 'bus', 'plane', 'car'],
  bathroom: ['bathroom'],
  sustainability: ['esg'],
};

export const imageSectionsArray = [
  { key: 'video', includeCategories: ['video'] },
  { key: 'description', includeCategories: ['hotel', 'lounge', 'interior'] },
  { key: 'accommodation', includeCategories: ['bathroom', 'bedroom'] },
  { key: 'foodAndBeverage', includeCategories: ['restaurant', 'food'] },
  { key: 'poolAndBeach', includeCategories: ['pool', 'beach'] },
  {
    key: 'sportsRelaxationEntertainment',
    includeCategories: ['gym', 'activity', 'sport', 'entertainment', 'spa'],
  },
  { key: 'kids', includeCategories: ['kids'] },
  {
    key: 'locationAndTransfer',
    includeCategories: ['transport', 'bus', 'plane', 'car'],
  },
  { key: 'bathroom', includeCategories: ['bathroom'] },
  { key: 'sustainability', includeCategories: ['esg'] },
];
